import { cn } from '@/lib/utils';

/** iOS 分段控件：灰色轨道 + 选中项白色浮起。 */
export function Segmented<T extends string | number>({
  value,
  options,
  onChange,
  className,
}: {
  value: T;
  options: readonly (readonly [T, string])[];
  onChange: (value: T) => void;
  className?: string;
}) {
  return (
    <div
      className={cn('grid gap-0.5 rounded-[9px] bg-muted p-0.5 ios:bg-[#767680]/12', className)}
      style={{ gridTemplateColumns: `repeat(${options.length}, minmax(0, 1fr))` }}
    >
      {options.map(([key, label]) => (
        <button
          key={String(key)}
          type="button"
          data-haptic
          onClick={() => onChange(key)}
          className={cn(
            'rounded-[7px] py-1.5 text-footnote transition-colors',
            value === key ? 'bg-card text-foreground font-semibold shadow-sm' : 'text-foreground/80',
          )}
        >
          {label}
        </button>
      ))}
    </div>
  );
}
